export default {
  'global.checkAll': 'Select all',
  'global.clearAll': 'Clear all',
  'global.empty': "Looks like there's nothing here!",
  'sort.asc': 'Sort ascending',
  'sort.desc': 'Sort descending',
};
